import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  postProjectsProjectIDJobsJobIDSubmit,
  type SubmitJobRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

export function useSubmitJobMutation(projectID: string, jobID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      (request: SubmitJobRequest) =>
        postProjectsProjectIDJobsJobIDSubmit(request, projectID, jobID),
      { translationPrefix: getResourcePath(Resources.ApiErrors.SubmitJob) },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.jobDetail(projectID, jobID),
      });
    },
  });
}
